export const BRAND_NAME = "MCTECH EVENTOS";
export const LOGO_HORIZONTAL = "https://customer-assets-lqy194kg.emergentagent.net/job_rifas-saas/artifacts/srkipgdc_Disen%CC%83o%20sin%20ti%CC%81tulo%20%281%29.jpg";
export const LOGO_SQUARE = "https://customer-assets-lqy194kg.emergentagent.net/job_rifas-saas/artifacts/ase5cvq8_Disen%CC%83o%20sin%20ti%CC%81tulo%20%282%29.jpg";
export const SUPPORT_WHATSAPP = "50664096004";
export const SUPPORT_EMAIL = "hola@mctecheventos.com";
